module.exports = __webpack_public_path__ + "media/images/turbochargers/turbo-0355e9c07f0029d944298d6e2bf0d2e5.png";